"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _compInfoInput = _interopRequireDefault(require("@/views/trial/videoTrial/demo/components/comp-info-input.vue"));
var _compDeviceSelect = _interopRequireDefault(require("@/views/trial/videoTrial/demo/components/comp-device-select.vue"));
var _compRoom = _interopRequireDefault(require("@/views/trial/videoTrial/demo/components/comp-room.vue"));
var _utils = require("@/views/trial/videoTrial/demo/components/utils/utils");
var _rtcDetect = _interopRequireDefault(require("rtc-detect"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "App",
  components: {
    compInfoInput: _compInfoInput.default,
    compDeviceSelect: _compDeviceSelect.default,
    compRoom: _compRoom.default
  },
  data: function data() {
    return {
      sdkAppId: 0,
      secretKey: "",
      userId: "",
      roomId: 0,
      cameraId: "",
      microphoneId: ""
    };
  },
  methods: {
    handleValueChange: function handleValueChange(value, key) {
      this[key] = value;
    },
    test: function () {
      var _test = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var detect, result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              detect = new _rtcDetect.default(); // 获得当前环境监测结果
              _context.next = 3;
              return detect.getReportAsync();
            case 3:
              result = _context.sent;
              // result 包含了当前环境系统的信息，API 支持度，编解码支持度，设备相关的信息
              console.log("result is: ", result);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function test() {
        return _test.apply(this, arguments);
      }
      return test;
    }()
  },
  mounted: function mounted() {
    // clearUrlParam();
    // 初始化监测模块
    this.test();
  }
};
exports.default = _default;